import React from 'react'
import SuccessHubBadge from 'src/components/growthEngine/SuccessHubBadge'
import SuccessHubCelebration from 'src/components/growthEngine/SuccessHubCelebration'
import { resolveSuccessHubReceiptWhy } from 'src/utils/growthEngineSuccessHub'

/**
 * Flagship Black Belt on Progress. Live hit uses the canned Hub line.
 * Quiet backfill is a prestige receipt card with why — not fireworks.
 */
const SuccessHubBlackBelt = ({
  blackBelt,
  celebrate = false,
  className,
  'data-testid': dataTestId = 'progress-black-belt',
}) => {
  if (!blackBelt?.earned) return null

  if (celebrate && blackBelt.congratulations) {
    return (
      <SuccessHubCelebration
        className={className}
        celebration={{
          displayName: blackBelt.displayName,
          outcome: blackBelt.congratulations,
          badge: blackBelt.badge,
        }}
        data-testid={`${dataTestId}-celebration`}
      />
    )
  }

  const why = resolveSuccessHubReceiptWhy(blackBelt)
  const badge = blackBelt.badge || {
    initials: 'BB',
    categoryId: 'prestige',
  }

  return (
    <SuccessHubBadge
      className={className}
      variant='receipt'
      prestige
      badge={badge}
      title={blackBelt.displayName}
      earnedAt={blackBelt.earnedAt}
      whyItMatters={why}
      data-testid={dataTestId}
    />
  )
}

export default SuccessHubBlackBelt
